import { useStore } from '@tmsw/powerups.store';
import './GamePiece.css';

function GamePiece(props) {
  const activeMiss = useStore((state) => state.activeMiss);

  const { hex, dragRef, className, style } = props;
  // console.log('GamePiece', props);

  return (
    <span
      className={`GamePiece ${className ?? null}`}
      ref={dragRef}
      style={{
        ...style,
        ...(activeMiss && activeMiss.sourceId === hex.id
          ? { filter: 'url(#cherry-icecream)' }
          : {}),
      }}
    />
  );
}

export default GamePiece;
